import { FaqCreate } from './faq-create.model';

export class Faq extends FaqCreate {
    public id: number;
    public created_at: string;
    public updated_at: string;
}
